import styled from "styled-components";

const GradientBg = styled.div`
  min-height: 100vh;
  position: relative;
  background: 
    radial-gradient(ellipse 80% 50% at 50% -20%, color-mix(in oklab, var(--primary) 8%, transparent) 0%, transparent 50%),
    radial-gradient(ellipse 60% 50% at 80% 50%, color-mix(in oklab, var(--gradient-end) 6%, transparent) 0%, transparent 50%),
    var(--background);
  
  &::before {
    content: '';
    position: fixed;
    inset: 0;
    background: 
      radial-gradient(circle at 20% 80%, color-mix(in oklab, var(--gradient-start) 4%, transparent) 0%, transparent 40%),
      radial-gradient(circle at 80% 20%, color-mix(in oklab, var(--primary) 5%, transparent) 0%, transparent 40%);
    pointer-events: none;
    opacity: 0.6;
  }
`;

export default GradientBg;
